import { graphql } from 'react-relay';
import type { GraphQLTaggedNode } from 'react-relay';

import { useEditorContentFragment } from '@confluence/editor-content-unified-query/entry-points/useEditorContentFragment.ts';
import type {
	EditorContentFragmentResult,
	EditorContentFragmentValue,
} from '@confluence/editor-content-unified-query/entry-points/useEditorContentFragment.ts';

import type { useEditorContentTypesHeaderFragment_content$key } from './__generated__/useEditorContentTypesHeaderFragment_content.graphql.ts';

// Copy of ContentTypesHeader_content for EditorContentUnifiedQuery: View Page spreads the shared
// fragment @relay(mask: false), which rules out @catch on it. Kept equal by a parity test.
const editorContentTypesHeaderFragmentNode: GraphQLTaggedNode = graphql`
	fragment useEditorContentTypesHeaderFragment_content on Content @catch {
		id
		title
		operations {
			operation
			targetType
		}
		space {
			id
			name
			key
			alias
		}
		type
		subType
		status
		smartFolderProperties: properties(keys: ["smartFolderProperties"]) {
			nodes {
				key
				value
			}
		}
		version {
			contentTypeModified
			number
			friendlyWhen
			by {
				displayName
			}
			when
		}
		draftVersion {
			contentTypeModified
			number
			friendlyWhen
			by {
				displayName
			}
			when
		}
	}
`;

/**
 * The header content from EditorContentUnifiedQuery. When the fragment is provided, the header
 * renders it instead of running ContentTypesHeaderQuery.
 */
export function useEditorContentTypesHeaderFragment(): EditorContentFragmentResult<
	EditorContentFragmentValue<useEditorContentTypesHeaderFragment_content$key>
> {
	return useEditorContentFragment<useEditorContentTypesHeaderFragment_content$key>(
		'contentTypesHeaderFragment',
		editorContentTypesHeaderFragmentNode,
	);
}
